export enum PylonAction {
  'show' = 'show',
  'hide' = 'hide',
  'onShow' = 'onShow',
  'onHide' = 'onHide',
  'hideChatBubble' = 'hideChatBubble',
  'showChatBubble' = 'showChatBubble',
  'onChangeUnreadMessageCount' = 'onChangeUnreadMessageCount',
  'setNewIssueCustomFields' = 'setNewIssueCustomFields',
}
